import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ContentWithCardLoading } from "../../../../components/loading";
import CustomPagination from "../../../../components/pagination/custom-pagination";
import ContentWrapper from "../../../Wrapper";
import AccountDetailsSubheader from "../../components/account-details-subheader";
import { getListOfLoginSessionsRequest } from "../../store/actions/account_login_session_actions";

export default function AccountLoginSessions({ match }) {

    const tabName = "Sessions";
    const [limit, setLimit] = useState(10);
    const [pageNo, setPageNo] = useState(1);

    const sessionStore = useSelector((state) => state.accounts.sessions);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getListOfLoginSessionsRequest({ limit: limit, page: pageNo, accountId: match.params.accountId }));
    }, [dispatch, limit, pageNo, match.params.accountId]);

    return (
        <ContentWrapper subHeader={<AccountDetailsSubheader active={tabName} />}>
            {sessionStore.loading ? (
                <ContentWithCardLoading />
            ) : (
                <div className={`card card-custom`}>
                    <div className="card-body py-3 px-3" style={{ padding: 15 }}>
                        <div className="table-responsive">
                            <table className="table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9">
                                <thead className="border-gray-200 fs-5 fw-bold bg-lighten">
                                    <tr>

                                        <td style={{ width: "20%" }}>{"Time"}</td>
                                        <td style={{ width: "20%" }}>{"Email"}</td>
                                        <td style={{ width: "20%" }}>{"IP Address"}</td>
                                        <td style={{ width: "20%" }}>{"Platform"}</td>
                                        <td style={{ width: "20%" }}>{"Location"}</td>
                                    </tr>
                                </thead>
                                <tbody className="fw-6 fw-bold text-gray-600">
                                    {sessionStore.loading ?
                                        <tr>
                                            <td colSpan="5" style={{ textAlign: "center" }}>
                                                <Spinner animation="border" variant="primary" />
                                            </td>
                                        </tr> : sessionStore.data.length === 0 ? (
                                            <>
                                                <tr>
                                                    <td colSpan="5" style={{ textAlign: "center", height: "300px", position: "relative", top: "70px" }}>
                                                        <h6>No Data To Show</h6>
                                                    </td>
                                                </tr>
                                            </>)
                                            : sessionStore.data.map((user, id) => {
                                                return (
                                                    <tr key={id}>
                                                        <td style={{ width: "22%" }}>
                                                            {new Intl.DateTimeFormat("en-US", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }).format(new Date(user.timeToLogin))} <br />
                                                            {user.timeToLogout !== undefined &&
                                                                new Intl.DateTimeFormat("en-US", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }).format(new Date(user.timeToLogout))}
                                                        </td>
                                                        <td style={{ width: "20%" }}>{user.userId.email}</td>
                                                        <td style={{ width: "23%" }}>{user.IPAddr}</td>
                                                        <td style={{ width: "20%" }}>{user.platform}</td>
                                                        <td style={{ width: "15%" }}>{user.location}</td>
                                                    </tr>
                                                );
                                            })

                                    }</tbody>
                            </table>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", paddingTop: 7, gap: 15, justifyContent: "flex-end" }} className="px-3">
                                <p style={{ fontSize: "1.075rem", marginTop: 5, marginBottom: 0 }}>
                                    Showing {(pageNo - 1) * limit + 1}-{sessionStore.count > pageNo * limit ? pageNo * limit : sessionStore.count} of {sessionStore.count}
                                </p>
                                {CustomPagination(pageNo, setPageNo, Math.ceil(sessionStore.count / limit), () => { }, limit, setLimit, sessionStore.count)}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </ContentWrapper>
    );
}